<template>
  <div class="colorful-background wrapper-grid special">
    <div
      :class="['title', { animate__animated: isFirst }, ' animate__flipInX']"
    >
      <span class="small-font is-block special-margin">
        共上课
      </span>
      <span class="big-font is-inline">
        {{ schedule_statistics.Lesson }}
        <span class="middle-font is-inline">
          课时
        </span>
      </span>
    </div>

    <div :class="['img', { animate__animated: isFirst }, ' animate__fadeIn']">
      <image-box img-u-r-l="/pic/12.png"></image-box>
    </div>

    <div
      :class="[
        'text',
        { animate__animated: isFirst },
        'animate__fadeIn',
        'text-align-right',
      ]"
    >
      <span class="small-font" style="align-self: stretch;">
        约合
      </span>
      <div style="display: flex; justify-content: flex-end; width: 100%;">
        <div>
          <span class="small-font is-block">
            {{ ((schedule_statistics.Lesson * 45) / 60 / 24).toFixed(0) }}
          </span>
          <span class="small-font is-block">
            {{ ((schedule_statistics.Lesson * 45) / 60).toFixed(0) }}
          </span>
          <span class="small-font is-block">
            {{ schedule_statistics.Lesson * 45 }}
          </span>
          <span class="small-font is-block">
            {{ schedule_statistics.Lesson * 45 * 60 }}
          </span>
        </div>

        <div>
          <span class="small-font is-block">
            天
          </span>
          <span class="small-font is-block">
            小时
          </span>
          <span class="small-font is-block">
            分
          </span>
          <span class="small-font is-block">
            秒
          </span>
        </div>
      </div>
    </div>

    <div
      :class="[
        'slogan',
        { animate__animated: isFirst },
        ' animate__fadeIn',
        'big-margin-top',
      ]"
    >
      <span class="small-font">
        {{ sloganForShow }}
      </span>
      <span class="small-font small-margin-top">
        {{ sloganForShow2 }}
      </span>
    </div>

    <div class="footer middle-margin-bottom">
      <div class="very-small-font">
        课程数据由杭电教务处提供,分析数据均在理想状态下计算
      </div>
      <span class="very-small-font">数据仅供参考</span>
    </div>
  </div>
</template>

<script>
import store from '@/store/store'
import ImageBox from '@/components/utils/imageBox'

export default {
  name: 'totalClassPage',
  components: { ImageBox },
  data() {
    return {
      sloganForShow: '是一个繁忙的学期，幸苦了',
      sloganForShow2: '小助手提醒:要劳逸结合哦',
      sloganList: [
        '虽然课时少，但是学习也要加油哦',
        '是一个繁忙的学期，幸苦了',
        '扶我起来,我还能学',
      ],
    }
  },
  props: {
    isFirst: { type: Boolean, default: true },
  },
  computed: {
    schedule_statistics: function () {
      return store.state.$data.data.Schedule.Statistics
    },
  },
  mounted() {
    let tempLesson = this.schedule_statistics.Lesson
    if (tempLesson < 200) {
      this.sloganForShow = this.sloganList[0]
      this.sloganForShow2 = ''
    } else if (tempLesson < 420) {
      this.sloganForShow = this.sloganList[1]
    } else {
      this.sloganForShow = this.sloganList[2]
    }
  },
}
</script>

<style scoped>
.img.animate__animated {
  animation-delay: var(--first-delay);
  animation-duration: var(--defalut-continue);
}

.title.animate__animated {
  animation-delay: var(--first-delay);
}

.text.animate__animated {
  animation-delay: var(--second-delay);
  animation-duration: var(--defalut-continue);
}

.slogan.animate__animated {
  animation-delay: var(--third-delay);
  animation-duration: var(--defalut-continue);
}

.wrapper-grid.special {
  --first-color: var(--hduhelp-blue);
  --page-background-color: var(--hdu-school-blue);
  --second-color: var(--eggplant-purple);
  grid-template-rows: 5vh repeat(4, minmax(auto, auto)) 1fr 5vh;
  grid-template-areas:
    '. .      .'
    '. title  .'
    '. img    .'
    '. text   .'
    '. slogan .'
    '. .      .'
    '. footer .';
}
</style>
